// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

import { isAdmin } from 'services/self'

import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Sidebar from 'components/Sidebar/Sidebar'
import SidebarHeader from 'components/Sidebar/SidebarHeader'
import MenuLink from 'components/MenuLink'
import { Typography } from '@mui/material'

export const SideNav = observer(() => isAdmin() && (
  <Sidebar className='sideNav'>
    <SidebarHeader>Admin</SidebarHeader>
    <Box sx={{ pl: 2, pt: 1 }}>
      <Typography sx={{ fontSize: '0.9rem' }}>Accounts</Typography>
      <Box sx={{ pt: 1}}>
        <MenuLink to='/admin/accounts'>Users</MenuLink>
        <MenuLink to='/admin/accounts/admins'>Admins</MenuLink>
        <MenuLink to='/admin/accounts/invites'>Invites</MenuLink>
      </Box>
    </Box>
    <MenuLink to='/admin/api-management'>API Management</MenuLink>
    <MenuLink to='/admin/client-management'>Client Management</MenuLink>
  </Sidebar>
))
